// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://gnosisscan.io/address/0xa767f745331D267c7751297D982b050c93985627
export const ETH__USD = '0xa767f745331D267c7751297D982b050c93985627';

// https://gnosisscan.io/address/0xeBbd67a84e33791F1bcFde74CDc22a71e332e2F1
export const GRT__USD = '0xeBbd67a84e33791F1bcFde74CDc22a71e332e2F1';

// https://gnosisscan.io/address/0x855193775eF2ABb12CF95DE3086229a14Ab8E0E3
export const GHO__USD = '0x855193775eF2ABb12CF95DE3086229a14Ab8E0E3';

// https://gnosisscan.io/address/0xB7B7d008c49295A0FF6Eed6dF4Ad3052Fd39d5e6
export const SOL__USD = '0xB7B7d008c49295A0FF6Eed6dF4Ad3052Fd39d5e6';

// https://gnosisscan.io/address/0xd98735d78266c62277Bb4dBf3e3bCdd3694782F4
export const UNI__USD = '0xd98735d78266c62277Bb4dBf3e3bCdd3694782F4';

// https://gnosisscan.io/address/0x26C31ac71010aF62E6B486D1132E266D6298857D
export const USDC__USD = '0x26C31ac71010aF62E6B486D1132E266D6298857D';

// https://gnosisscan.io/address/0xC0a6Bf8d5D408B091D022C3C0653d4056D4B9c01
export const SUSHI__USD = '0xC0a6Bf8d5D408B091D022C3C0653d4056D4B9c01';

// https://gnosisscan.io/address/0x3b84d6e6976D5826500572600eB44f9f1753827b
export const SNX__USD = '0x3b84d6e6976D5826500572600eB44f9f1753827b';

// https://gnosisscan.io/address/0x3c30c5c415B2410326297F0f65f5Cbb32f3aefCc
export const DOT__USD = '0x3c30c5c415B2410326297F0f65f5Cbb32f3aefCc';

// https://gnosisscan.io/address/0x4a5AB0F60d12a4420d36D3eD9A1F77d8c47EB94c
export const XAU__USD = '0x4a5AB0F60d12a4420d36D3eD9A1F77d8c47EB94c';

// https://gnosisscan.io/address/0x00288135bE38B83249F380e9b6b9a04c90EC39eE
export const WBTC__USD = '0x00288135bE38B83249F380e9b6b9a04c90EC39eE';

// https://gnosisscan.io/address/0x14030d5a0C9e63D9606C6f2c8771Fc95b34b07e0
export const YFI__USD = '0x14030d5a0C9e63D9606C6f2c8771Fc95b34b07e0';

// https://gnosisscan.io/address/0xFb00261Af80ADb1629D3869E377ae1EEC7bE659F
export const CHF__USD = '0xFb00261Af80ADb1629D3869E377ae1EEC7bE659F';

// https://gnosisscan.io/address/0x0064AC007fF665CF8D0D3Af5E0AD1c26a3f853eA
export const wstETH_ETH_Exchange_Rate = '0x0064AC007fF665CF8D0D3Af5E0AD1c26a3f853eA';

// https://gnosisscan.io/address/0xab70BCB260073d036d1660201e9d5405F5829b7a
export const EUR__USD = '0xab70BCB260073d036d1660201e9d5405F5829b7a';

// https://gnosisscan.io/address/0xF937ffAeA1363e4Fa260760bDFA2aA8Fc911F84D
export const AAVE_Network_Emergency_Count_Gnosis_Chain =
  '0xF937ffAeA1363e4Fa260760bDFA2aA8Fc911F84D';

// https://gnosisscan.io/address/0x0CaE8f5c10931f0Ce87Ed9BbB71391C6E93C2C26
export const FTT__USD = '0x0CaE8f5c10931f0Ce87Ed9BbB71391C6E93C2C26';

// https://gnosisscan.io/address/0xBa95Bc8418Ebcdf8a690924E1d4aD5292139F2EA
export const COMP__USD = '0xBa95Bc8418Ebcdf8a690924E1d4aD5292139F2EA';

// https://gnosisscan.io/address/0xed322A5ac55BAE091190dFf9066760b86751947B
export const LINK__USD = '0xed322A5ac55BAE091190dFf9066760b86751947B';

// https://gnosisscan.io/address/0x824b4A1A0443609A2ADd94a700b770FA5bE31287
export const DOGE__USD = '0x824b4A1A0443609A2ADd94a700b770FA5bE31287';

// https://gnosisscan.io/address/0xC77B83ac3Dd2a761073bD0f281f7b880B2DDDe18
export const CRV__USD = '0xC77B83ac3Dd2a761073bD0f281f7b880B2DDDe18';

// https://gnosisscan.io/address/0x6D42cc26756C34F26BEcDD9b30a279cE9Ea8296E
export const BNB__USD = '0x6D42cc26756C34F26BEcDD9b30a279cE9Ea8296E';

// https://gnosisscan.io/address/0x27d4D36968a2BD1Cc3406D99cB1DF50561dBf2a4
export const REN__USD = '0x27d4D36968a2BD1Cc3406D99cB1DF50561dBf2a4';

// https://gnosisscan.io/address/0x2997eBa3d9c2447c36107bB0F082b8c33566b49c
export const ZIL__USD = '0x2997eBa3d9c2447c36107bB0F082b8c33566b49c';

// https://gnosisscan.io/address/0x911e08A32A6b7671A80387F93147Ab29063DE9A2
export const AVAX__USD = '0x911e08A32A6b7671A80387F93147Ab29063DE9A2';

// https://gnosisscan.io/address/0xc5f7665e7FdC5059B93Db8bEAB83F5ffA05Eb18e
export const osETH__ETH_Exchange_Rate = '0xc5f7665e7FdC5059B93Db8bEAB83F5ffA05Eb18e';

// https://gnosisscan.io/address/0x2b481Dc923Aa050E009113Dca8dcb0daB4B68cDF
export const AAVE__USD = '0x2b481Dc923Aa050E009113Dca8dcb0daB4B68cDF';

// https://gnosisscan.io/address/0xe9cea51a7b1b9B32E057ff62762a2066dA933cD2
export const MXN__USD = '0xe9cea51a7b1b9B32E057ff62762a2066dA933cD2';

// https://gnosisscan.io/address/0x1b723C855F7D2c2785F99486973271355e782d77
export const BAL__USD = '0x1b723C855F7D2c2785F99486973271355e782d77';

// https://gnosisscan.io/address/0x2AfB993C670C01e9dA1550c58e8039C1D8b8A317
export const JPY__USD = '0x2AfB993C670C01e9dA1550c58e8039C1D8b8A317';

// https://gnosisscan.io/address/0x6C1d7e76EF7304a40e8456ce883BC56d3dEA3F7d
export const BTC__USD = '0x6C1d7e76EF7304a40e8456ce883BC56d3dEA3F7d';

// https://gnosisscan.io/address/0x76e76F7E73F3BD42E3c2b4282B50b36E78130B4A
export const PERP__USD = '0x76e76F7E73F3BD42E3c2b4282B50b36E78130B4A';

// https://gnosisscan.io/address/0xF826E3ff8c0481D2e58DB9d301936F94Cd4fa916
export const UMA__USD = '0xF826E3ff8c0481D2e58DB9d301936F94Cd4fa916';

// https://gnosisscan.io/address/0x678df3415fc31947dA4324eC63212874be5a82f8
export const DAI__USD = '0x678df3415fc31947dA4324eC63212874be5a82f8';

// https://gnosisscan.io/address/0x68811D7DF835B1c33e6EEae8E7C141eF48d48cc7
export const USDT__USD = '0x68811D7DF835B1c33e6EEae8E7C141eF48d48cc7';

// https://gnosisscan.io/address/0x22441d81416430A54336aB28765abd31a792Ad37
export const GNO__USD = '0x22441d81416430A54336aB28765abd31a792Ad37';

// https://gnosisscan.io/address/0x229e486Ee0D35b7A9f668d10a1e6029eEE6B77E0
export const STETH__USD = '0x229e486Ee0D35b7A9f668d10a1e6029eEE6B77E0';

// https://gnosisscan.io/address/0xc89077976e03d19057eb296215C15afAe4A7464B
export const LINK__DAI = '0xc89077976e03d19057eb296215C15afAe4A7464B';

// https://gnosisscan.io/address/0xFDF9EB5fafc11Efa65f6FD144898da39a7920Ae8
export const _1INCH__USD = '0xFDF9EB5fafc11Efa65f6FD144898da39a7920Ae8';

export const CHAIN_ID = 100;
